/**
 * Blocs exportables du rapport client JSON (UI modale + build).
 */

export const CLIENT_REPORT_SCHEMA_VERSION = '1.1';

export const SEO_URLS_VOLUME_WARNING = 200;

/** @typedef {{ id: string, label: string, description: string, defaultEnabled: boolean, required?: boolean }} ClientReportBlockDef */

/** @type {ClientReportBlockDef[]} */
export const CLIENT_REPORT_BLOCKS = [
  {
    id: 'meta',
    label: 'Métadonnées & périmètre',
    description: 'Nom du projet, URL, date d’export, version du schéma, langue auditée, nombre d’URLs auditées.',
    defaultEnabled: true,
    required: true,
  },
  {
    id: 'scores',
    label: 'Scores & libellés',
    description: 'Scores global, SEO, performance, technique et qualificatifs associés.',
    defaultEnabled: true,
  },
  {
    id: 'narrative',
    label: 'Verdict & narration',
    description: 'Verdict global, impacts par pilier et projection indicative du score.',
    defaultEnabled: true,
  },
  {
    id: 'siteIdentity',
    label: 'Carte d\'identité du site',
    description: 'Secteur, compréhension IA, description, stack technique (CMS, hébergeur, outils), llm.txt, sitemap et couverture d\'audit.',
    defaultEnabled: true,
  },
  {
    id: 'geo',
    label: 'Visibilité / marché (GEO)',
    description: 'Points forts, points faibles et recommandations de positionnement (LLM / GEO).',
    defaultEnabled: true,
  },
  {
    id: 'seoInsights',
    label: 'Recommandations SEO projet',
    description: 'Synthèse et recommandations prioritaires IA/projet (hors tableau des URLs).',
    defaultEnabled: true,
  },
  {
    id: 'technical',
    label: 'Erreurs techniques (plan global)',
    description: 'Plan de correction agrégé sur tout le site (priorité, impact, effort, exemples d’URLs).',
    defaultEnabled: true,
  },
  {
    id: 'commonFindings',
    label: 'Retours communs (pages de référence)',
    description: 'Problèmes récurrents détectés sur l’ensemble des pages de référence.',
    defaultEnabled: true,
  },
  {
    id: 'referencePages',
    label: 'Pages de référence (fiche complète)',
    description: 'Même contenu que l’export CSV IA : données structurées, champs formatés (critères, Hn, images, PageSpeed, plan IA) et fullNarrativeForAi par page.',
    defaultEnabled: true,
  },
  {
    id: 'seoUrlsTable',
    label: 'Tableau « Analyse SEO des URLs »',
    description: 'Toutes les URLs auditées : scores, critères détaillés, statuts title/meta, H1, images, canonical, impact business, synthèse santé des critères et fullTableNarrativeForAi.',
    defaultEnabled: true,
  },
];

export const CLIENT_REPORT_BLOCK_IDS = CLIENT_REPORT_BLOCKS.map((b) => b.id);

export function defaultEnabledBlockIds() {
  return CLIENT_REPORT_BLOCKS.filter((b) => b.defaultEnabled).map((b) => b.id);
}

export function storageKeyForProject(slug) {
  return `clientReportExport:${slug || 'project'}`;
}
